
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Card,
    CardContent,
    Typography,
    CardActionArea,
    Chip
} from '@mui/material';

const DEFAULT_IMAGE_PATH = "/img/img.png";

const getImageUrl = (imagePath) => {
    if (!imagePath) return process.env.PUBLIC_URL + DEFAULT_IMAGE_PATH;

    // Default to uploads directory
    return `https://tikrai.com/api/images/${imagePath}`;
};

// Format price with euro sign
const formatPrice = (price) => {
    if (!price && price !== 0) return '';
    return `€${parseFloat(price).toFixed(2)}`;
};

const ProductCard = ({ card, index }) => {
    const navigate = useNavigate();
    return (
        <Card onClick={() => navigate(`/product/${card.alias}`)}
              className="card shadow-soft"
              sx={{
                  width: '100%',
                  borderRadius: 2,
                  boxShadow: '0 4px 18px rgba(0, 0, 0, 0.06)',
                  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                  overflow: 'hidden',
                  background: '#fff',
                  border: '1px solid rgba(0, 0, 0, 0.06)',
                  '&:hover': { transform: 'translateY(-3px)', boxShadow: '0 10px 24px rgba(0,0,0,0.10)' }
              }}
        >
            <CardActionArea
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                }}
            >
                <Box sx={{position: 'relative', overflow: 'hidden'}}>
                    <Box
                        component="img"
                        src={card.image ? `${getImageUrl(card.image)}.png` : `${process.env.PUBLIC_URL}${DEFAULT_IMAGE_PATH}`}
                        alt={card?.name ? `${card.name} – produkto nuotrauka` : 'Product image'}
                        width={240}
                        height={170}
                        loading="lazy"
                        decoding="async"
                        onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = `${process.env.PUBLIC_URL}${DEFAULT_IMAGE_PATH}`; }}
                        sizes="(max-width: 600px) 50vw, 240px"
                        sx={{
                            transition: 'transform 0.3s ease-in-out',
                            objectFit: 'cover',
                            width: '100%',
                            height: 170,
                            display: 'block'
                        }}
                    />
                    {/* Price badges positioned on the image */}
                    {card.previousPrice && card.previousPrice !== card.lastPrice && (
                        <Chip
                            label={formatPrice(card.previousPrice)}
                            sx={{
                                position: 'absolute',
                                top: 8,
                                left: 8,
                                backgroundColor: 'rgba(255,255,255,0.9)',
                                color: 'text.primary',
                                fontWeight: 600,
                                fontSize: '0.72rem',
                                border: '1px solid var(--line)',
                                '& .MuiChip-label': {
                                    padding: '4px 8px',
                                    textDecoration: 'line-through',
                                },
                            }}
                            variant="outlined"
                        />
                    )}
                    {card.lastPrice && (
                        <Chip
                            label={formatPrice(card.lastPrice)}
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: 'var(--primary)',
                                color: 'var(--white)',
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                backdropFilter: 'blur(4px)',
                                '& .MuiChip-label': {
                                    padding: '4px 8px',
                                },
                            }}
                        />
                    )}
                </Box>
                <CardContent
                    sx={{
                        padding: 1,
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 0.5,
                    }}
                >
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            fontWeight: 600,
                            fontSize: '0.8rem',
                            lineHeight: 2.2,
                            color: 'text.primary',
                            marginBottom: 0.5,
                        }}
                    >
                        {card.name}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            lineHeight: 2.4,
                            fontSize: '0.6rem',
                            marginBottom: 1,
                        }}
                    >

                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default ProductCard;